<template>
    <div id="nucarf-saas-head-wrap">
        <div id="nucarf-saas-head">
            <div class="left head-left flex flex-1">
                <div>
                    <i
                        class="iconfont icon-daohang  pointer font_16"
                        style="color: #424562;margin:0 26px 0 15px"
                        @click="handleClose(true)"
                    />
                </div>
                <h2 />
                <h1 class="stream">
                    牛卡福企业数字化平台
                </h1>
            </div>
            <div class="right flex">
                <el-dropdown>
                    <div
                        id="user-name"
                        class="nav-user flex stream"
                    >
                        <i
                            class="iconfont el-forusercenter"
                            style="fontSize:24px"
                        />
                        <span>{{ newUser.name?newUser.name:'' }}</span>
                        <i class="el-icon-arrow-down" />
                    </div>
                    <el-dropdown-menu
                        slot="dropdown"
                        style="width:140px;"
                    >
                        <el-dropdown-item
                            id="dropdown-change-pwd"
                            icon="el-icon-circle-close"
                            @click.native="isDialog=true;console.log('退出')"
                        >
                            退出登录
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :show-close="false"
            size="283px"
        >
            <div slot="title">
                <div class="flex">
                    <img
                        src="@/assets/images/nav/nucarf.png"
                        style="width:100px;height:33px;margin:23px 117px 23px 26px"
                    >
                    <img
                        src="@/assets/images/nav/close.png"
                        class="pointer"
                        style="width:17px;height:16px;marginTop:31px"
                        @click="handleClose(false)"
                    >
                </div>
            </div>
            <div class=" font_20 font_500 nav_prod">
                牛卡福产品导航
            </div>
            <ul class="nav_list">
                <li
                    v-for="(item,key) in imgs "
                    :key="key"
                    class="flex margin-b-20 pointer"
                    :class="active==key?'active':''"
                    @mouseenter="handleTab(key)"
                    @mousemove="handleTab(key)"
                    @click="handleClick(key,item.href)"
                >
                    <img
                        :src="item.img"
                        style="width:auto;height:36px"
                        alt=""
                    >
                    <span>
                        <div
                            style="fontSize:15px"
                            class="nav_title font_500"
                        >
                            {{ item.title }}
                        </div>
                        <div
                            style="fontSize:12px"
                            class="nav_dis"
                        >
                            {{ item.dis }}
                        </div>
                    </span>
                </li>
            </ul>
        </el-drawer>
        <nf-confirm
            :show.sync="isDialog"
            :handle-save-btn-click="handlelogoutClick"
            scrollbar-h="70px"
        >
            <div slot="content">
                确定退出登录吗 ？

            </div>
        </nf-confirm>
        <nf-confirm
            :show.sync="isDialog"
            :handle-save-btn-click="handlelogoutClick"
            scrollbar-h="60px"
        >
            <div slot="content">
                确定退出登录吗 ？
            </div>
        </nf-confirm>
    </div>
</template>
<script>
import nfConfirm from '@/components/nf-confirm/index'
import { logout } from '@/api/auth';
import Cookies from 'js-cookie';
export default {
    components: {
        nfConfirm
    },
    data () {
        return {
            promptPwdWidth: '',
            isDialog: false,
            navList: [],
            maxNavList: 5,
            searchText: '',
            active: 2,
            drawer: false,
            direction: 'ltr',
            imgs: [
                { img: require('../../assets/images/nav/niuyunbao.png'), title: "牛运宝", dis: "一站式智慧物流服务平台", href: "https://1.nucarf" },
                { img: require('../../assets/images/nav/wanjinyou.png'), title: "万金油", dis: "智能加油管理解决方案", href: "https://vip.nucarf.net/" },
                { img: require('../../assets/images/nav/wanliu.png'), title: "万流数据", dis: "智能通行费发票解决方案", href: "https://cloud.nucarf.net" }
            ]
        }
    },
    computed: {
        companyList () {
            return this.$store.state.companyList
        },
        userInfo () {
            return this.$store.state.userInfo
        },
        newUser () {
            return this.$store.state.newUser
        }
    },
    watch: {
        newUser: {
            handler (newval) {
                this.$store.commit('upNewUser', newval)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleTab (val) {
            this.active = val
        },
        handleClick (key, val) {
            if (key === 1) {
                window.open(val, '_blank')
            } else if (key === 0) {
                let res = window.location.host.substring(window.location.host.lastIndexOf('.') + 1)
                window.location.href = val + "." + res
                // window.open(val + "." + res, '_blank')
            } else {
                this.drawer = false
            }
        },
        handleClose (val) {
            if (val) {
                this.active = 2
            }
            this.drawer = val
        },
        handleToUrlTap (link) {
            window.location.href = link;
        },
        async handlelogoutClick (done) {
            console.log('handlelogoutClick');
            done();
            let res = await logout()
            try {
                if (res.code === 200) {
                    localStorage.clear()
                    sessionStorage.clear()
                    const domain =  `nucarf.${window.location.hostname.split('.')[window.location.hostname.split('.').length - 1]}`
                    Cookies.remove('ShippersUserInfo', { domain: domain });
                    window.location.href = "/login"
                }
            } catch (err) {
                return err
            }
            done(false);
        },
        clearAllCookie () {
            let date = new Date();
            date.setTime(date.getTime() - 10000);
            let keys = document.cookie.match(/[^ =;]+(?==)/g);
            let tech = window.location.host.split('.')[2]
            if (keys) {
                for (let i = keys.length; i--;) {
                    document.cookie = `${keys[i]}=0;expire=${date.toGMTString()};path=/;domain=.nucarf.${tech}`
                }
            }
        }
    }
}
</script>
<style scoped  lang="scss">
$header-height: 60px;
#nucarf-saas-head-wrap {
    height: $header-height;
    width: 100%;
    position: relative;
    /deep/.el-dropdown {
        padding: 0 !important;
        color: rgba(255, 255, 255, 0.6);
        font-size: 13px;
    }
    .head-left {
        align-items: center;
    }
}
#user-name {
    span {
        display: inline-block;
        margin: 0 5px;
    }
}
.stream {
    letter-spacing: 1px;
}
h2 {
    width: 33px;
    height: 37.5px;
    background: url('./images/logo nucarf@3x.png') no-repeat center;
    background-size: 80%;
    display: inline-block;
    text-indent: -9999rem;
    margin-left: 0px;
}
.company-name {
    font-size: 16px;
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    margin-left: 24px;
    flex: 1;
    cursor: pointer;
}
.icontouxiang {
    font-size: 28px;
    color: #ffffffa6;
    font-size: 23px;
}
#nucarf-saas-head {
    height: $header-height;
    background: #0056ff;
    right: 0;
    color: rgba(250, 255, 255, 0.9);
    display: flex;
    padding-left: 4px;
    padding-right: 20px;
    left: 0;
    top: 0;
    align-items: center;
    box-sizing: border-box;
    padding-right: 0;
    z-index: 23;
}
#nucarf-saas-head > div {
    height: $header-height;
}
#nucarf-saas-head h1 {
    font-size: 18px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    margin-right: 20px;
    height: $header-height;
    line-height: $header-height;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 5px;
    cursor: pointer;
}
#nucarf-saas-head .top-nav {
    flex: 1;
}
#nucarf-saas-head .top-nav,
.seting-nav,
.seting-nav {
    display: flex;
    font-size: 13px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.6);
    height: $header-height;
    line-height: $header-height;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.el-icon-arrow-down {
    transition: all 0.3s;
    font-size: 18px;
}
#nucarf-saas-head .top-nav div:hover {
    color: #fff;
    background: #2266d0;
}

#nucarf-saas-head .top-nav div {
    padding: 0 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
#nucarf-saas-head .right {
    align-items: center;
}

#nucarf-saas-head .nav-user {
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    height: $header-height;
    display: flex;
    align-items: center;
    color: rgba(250, 255, 255, 0.9);
    margin-right: 10px;
}
#nucarf-saas-head .nav-user span {
    padding: 0 4px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nav-search {
    height: 33px;
    width: 245px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.3);
    padding: 8px 15px;
    box-sizing: border-box;
    input::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 1);
    }
    input {
        color: rgba(255, 255, 255, 1);
        line-height: 17px;
        height: 17px;
        font-size: 12px;
        font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
            '微软雅黑', Arial, sans-serif;
        font-weight: 400;
        width: 100%;
    }
}
.financial {
    margin-left: 20px;
    margin-right: 24px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    cursor: pointer;
}
/deep/ .el-drawer__header {
    height: 79px;
    padding: 0 !important;
    margin: 0 !important;
    border-bottom: 1px solid #f1f1f1;
}

.nav_prod {
    width: 140px;
    height: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #0b1527;
    line-height: 28px;
    margin: 29px 0 32px 26px;
}
.nav_list {
    .active {
        background: #f8f9fc;
    }
    li {
        height: 67px;
        img {
            margin: 14px 21px 15px 27px;
            width: 38px;
            height: 38px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #f1f1f1;
        }
        .nav_title {
            height: 21px;
            margin: 12px 0 5px;
            line-height: 21px;
            color: #333333;
        }
        .nav_dis {
            height: 17px;
            line-height: 17px;
            color: #9b9b9b;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
        }
    }
}
</style>

